import { render, staticRenderFns } from "./BatterPermissions.vue?vue&type=template&id=776a5842"
import script from "./BatterPermissions.vue?vue&type=script&lang=js"
export * from "./BatterPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports